import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './component.scss'

// ルートクラス定義
const ROOT_TARGET_CLASS_NAME = 'js-searchResultView-root-target'
const ROOT_TARGET_SELECTOR = `.${ROOT_TARGET_CLASS_NAME}`

const searchResultViewMore = () => {
  // セレクタ定義
  const TRIGGER_CLASS_NAME = 'js-searchResultViewMore-trigger'
  const TRIGGER_SELECTOR = `.${TRIGGER_CLASS_NAME}`

  const TARGET_CLASS_NAME = 'js-searchResultViewMore-target'
  const TARGET_SELECTOR = `.${TARGET_CLASS_NAME}`

  const SWITCH_LOADING_DISPLAY_TARGET_CLASS_NAME = 'js-switchLoadingDisplay-target'
  const SWITCH_LOADING_DISPLAY_TARGET_SELECTOR = `.${SWITCH_LOADING_DISPLAY_TARGET_CLASS_NAME}`

  // 開いた状態のクラス定義
  const SHOW_CLASS_NAME = 'is-show'

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  // $rootElementがない場合は処理を終了する
  if ($rootElement.length === 0) {
    return
  }

  const $searchResultViewMoreTrigger = $rootElement.find(TRIGGER_SELECTOR)
  const $switchLoadingDisplayTarget = $rootElement.find(SWITCH_LOADING_DISPLAY_TARGET_SELECTOR)
  const $searchResultViewMoreTarget = $rootElement.find(TARGET_SELECTOR)

  // クリックイベント登録
  $searchResultViewMoreTrigger.on('click', (event) => {
    event.preventDefault()

    // ローディングの表示処理
    if ($switchLoadingDisplayTarget.hasClass(SHOW_CLASS_NAME)) {
      $switchLoadingDisplayTarget.hide()
      $switchLoadingDisplayTarget.removeClass(SHOW_CLASS_NAME)
    } else {
      $switchLoadingDisplayTarget.show()
      $switchLoadingDisplayTarget.addClass(SHOW_CLASS_NAME)
    }

    const offset = $searchResultViewMoreTrigger.data('offset')
    const totalCount = $searchResultViewMoreTrigger.data('totalCount')
    const prefectureId = $searchResultViewMoreTrigger.data('prefectureId')
    const cityId = $searchResultViewMoreTrigger.data('cityId')
    const partTypes = $searchResultViewMoreTrigger.data('partTypes')

    // 非同期通信の処理
    $.ajax({
      url: '/subsidies/api/search_result',
      method: 'GET',
      dataType: 'html',
      data: { offset: offset, prefecture_id: prefectureId, city_id: cityId, part_types: partTypes },
      success: function (data) {
        // ローディングの非表示処理
        $switchLoadingDisplayTarget.hide()
        $switchLoadingDisplayTarget.removeClass(SHOW_CLASS_NAME)
        // 取得したデータを追加表示
        $searchResultViewMoreTarget.before(data)
        if (offset + 10 >= totalCount) {
          $searchResultViewMoreTrigger.hide()
        } else {
          // offsetの更新
          $searchResultViewMoreTrigger.data('offset', offset + 10)
        }
      },
      error: function (error) {
        console.error('Error fetching partial:', error)
      }
    })
  })
}

$(() => {
  // ローディングの表示処理
  searchResultViewMore()
})
